import { DOCUMENT, KeyValue } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { BehaviorSubject } from 'rxjs';
import { ContractService } from '../service/contract.service';
import { MessageService } from 'primeng/api';
import { DialogService } from '../../../../services/dialog.service';
import { ProgressSpinerService } from '../../../../services/progress-spiner.service';
import { saveAs as importedSaveAs } from 'file-saver';
@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrl: './training.component.scss',
})
export class TrainingComponent {
  myOptions!: object;
  bodySpinner: boolean = false;
  selectedDate: any;
  terminateDate: any;
  activeStep: number = 1;
  questionsForm: FormGroup = new FormGroup({});
  rfpconfigFrom: FormGroup = new FormGroup({});
  excelSheetForm: FormGroup = new FormGroup({});
  sheetDataForm: FormGroup = new FormGroup({});
  rfpList: any[] = [];
  submitted: boolean = false;
  metricFullscreen: boolean = false;
  spinner: boolean = false;
  selectedRfp: any;
  listSearch: any;
  documentSearch: any;
  loading: boolean = true;
  documentListData: any[] = [];
  client_id: any;
  clientList: any[] = [];
  showUpdateButton: boolean = false;
  selectedRfPDetails: any;
  selectedCompanyDetails: any;
  fileData: any;
  fileLLMformData: FormData = new FormData();
  uploadFileForm: FormGroup = new FormGroup({});
  uploadSelectFile: any[] = [];
  docSummary: any;
  selectedFilePreview: any;
  RFPDocPayLoad: any;
  pageNo: number = 0;
  limit: number = 25;
  total_records: number = 0;
  total_pages: number = 0;
  progressLoader: boolean = false;
  previewFileType: any;
  excelDataList: any[] = [];
  selectedCompanyId: any;
  companyListData: any[] = [];
  dropdownIndex: any;
  editTrainId: any;
  tabContent: any;
  showToolspopUp: boolean = false;
  private _isProcessingFiles: boolean = false;
  private _activeInputType: 'doc' | 'xls' | null = null;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('existModal') existModal!: ElementRef;
  @ViewChild('closebutton') closebutton!: ElementRef;
  @ViewChild('excelFile') excelFile!: ElementRef;
  @ViewChild('docFileInput') docFileInput!: ElementRef;
  @ViewChild('xlsFileInput') xlsFileInput!: ElementRef;
  /********Excel*********/
  title = 'excel-viewer';
  dataExcel: any = {};
  isFetched = false;
  stopFetching = false;
  eventEmitter = new BehaviorSubject<any>({});
  isEditing = false;
  sheetNames: string[] = ['Sheet1'];
  /********Excel********/
  previewDocFileName: any;
  previewDocId: any;
  selectedDocuments: Set<string> = new Set();
  selectAll: boolean = false;
  botEnabled: boolean = false;
  currentUserDetail: any;
  uploadFiletype: any = null;
  showsheetform: boolean = false;
  sheetslist: any[] = [];
  sheetDetail: any = {};
  document_details: any = {};
  isModalVisible: boolean = false;
  seletedModal: any;
  popLoader: boolean = false;
  botQAList: any[] = [];
  botExpand: boolean = false;
  historySearch: any;
  historyPayload: any;
  historyTotalRecords: number = 0;
  pinPayload: any;
  botQAPinnedList: any[] = [];
  pinnedTotalRecords: number = 0;
  selectedPinRecord: any = {};
  isFileGenModalVisible: boolean = false;
  genFiletyleList: any = {
    filetype: [
      { label: 'Save as a word document', type: 'docx' },
      { label: 'Save as a pdf', type: 'pdf' },
    ],
  };
  queryTypes: any[] = [
    { label: 'Private', type: 'private' },
    { label: 'Generic', type: 'public' },
  ];
  botQAgenFile: any = null;
  botQAGenFilePayLoad: any;
  botQAFilespayload: any;
  botQAFileList: any[] = [];
  botFilesTotalRecords: number = 0;
  botAudioFilesTotalRecords: number = 0;
  urlSafe!: SafeResourceUrl;
  loader: boolean = false;
  botQAAudioFileList: any[] = [];
  queryType: any = 'private';
  documentsAllList: any[] = [];
  documentSection: any = null;
  selectAllDocument: boolean = false;
  isDragOver: boolean = false;
  fileSheetMap: { file_name: string; file: File; sheets: any[] }[] = [];

  selectedParentRfpId: any = null;
  selectedParentRfpDetails: any = null;
  parentRfpSelectedList: any[] = [];
  editingIsSubcategory: boolean = false;
  private _preEditSelectedRfp: any = null;
  private _preEditSelectedRfPDetails: any = null;
  private _preEditParentRfpId: any = null;
  private _preEditParentRfpDetails: any = null;
  private readonly notifier: NotifierService;
  constructor(
    private notifierService: NotifierService,
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document: Document,
    private messageService: MessageService,
    private infosecService: ContractService,
    private sanitizer: DomSanitizer,
    private dialogService: DialogService,
    private ProgressLoader: ProgressSpinerService,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.bodySpinner = true;

    this.questionsForm = this.fb.group({
      questions: this.fb.array([]),
    });
    this.rfpconfigFrom = this.fb.group({
      client_id: [''],
      company_id: [''],
      type_name: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z0-9\s\-\&]*$/)],
      ],
      description: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z0-9\s\-\'\&]*$/)],
      ],
      is_active: [true],
      parent_id: [''],
      id: [''],
    });

    this.uploadFileForm = this.fb.group({
      title: [''],
    });
    this.excelSheetForm = this.fb.group({
      file_name: '',
      sheets: this.fb.array([]),
    });

    this.infosecService.getClient().subscribe(
      (response: any) => {
        if (response.length > 0) {
          this.clientList = response;
          //this.client_id=this.clientList[0]['id'];
          if (this.clientList.length > 0) {
            this.client_id = this.clientList[0]['id'];
            this.rfpconfigFrom.controls['client_id'].setValue(this.client_id);
          }
        }
      },
      (error: HttpErrorResponse) => {},
    );

    this.getCompanyList();
    //this.getRFPtypesList();

    // this.rfpList = [
    //     {
    //       "id":1,
    //       "name":"Service",
    //       "status":true
    //     },
    //     {
    //       "id":2,
    //       "name":"Product",
    //       "status":true
    //     }
    // ];
    this.documentListData = [];

    this.infosecService.getCurrentUser().subscribe({
      next: (response: any) => {
        this.currentUserDetail = response;
      },
      error: (errors: HttpErrorResponse) => {},
    });

    this.documentSection = 'single';
  }

  get questions(): FormArray {
    return this.questionsForm.get('questions') as FormArray;
  }

  // Method to create a new skill FormGroup
  newQuestion(): FormGroup {
    return this.fb.group({
      question: ['', Validators.required],
    });
  }

  // Method to dynamically add a new skill
  addQuestion() {
    this.questions.push(this.newQuestion());
  }

  // Method to dynamically remove a skill at a specific index
  removeQuestion(i: number) {
    this.questions.removeAt(i);
  }

  getDateSearchData(event: any) {}

  activateCallback(stepper: number) {
    this.activeStep = stepper;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);
    this.addQuestion();
  }

  selectStepper(step: number) {
    this.activeStep = step;
  }

  // selectedList(company: any, items: any) {
  //   this.documentListData = [];
  //   this.pageNo = 0;
  //   this.total_pages = 0;
  //   this.selectedCompanyId = company['id'];
  //   this.selectedCompanyDetails = company;
  //   this.selectedRfp = items['id'];
  //   this.selectedRfPDetails = items;
  //   // this.selectedRfPDetails = this.rfpList.filter(list=>list['id']==index)[0];
  //   this.pageNo++;
  //   this.selectedDocuments.clear();
  //   this.selectAll = false;
  //   this.getRFPDocuments();
  // }
  selectedList(company: any, items: any) {
    this.documentListData = [];
    this.pageNo = 1;
    this.total_pages = 0;
    this.selectedCompanyId = company['id'];
    this.selectedCompanyDetails = company;
    this.selectedRfp = items['id'];
    this.selectedRfPDetails = items;
    this.selectedParentRfpId = company['id'];
    this.selectedParentRfpDetails = company;
    this.selectedDocuments.clear();
    this.selectAll = false;
    this.getRFPDocuments();
  }

  // selectCompany(items: any) {
  //   this.selectedCompanyId = items['id'];
  //   this.selectedCompanyDetails = items;
  //   this.selectedRfp = null;

  //   this.pageNo = 0;
  //   this.total_pages = 0;
  //   this.pageNo++;
  //   this.selectedDocuments.clear();
  //   this.selectAll = false;
  //   this.getRFPDocuments();
  //   // if(items.child.length > 0){
  //   //     this.selectedRfp = items.child[0]['id'];
  //   //     this.selectedRfPDetails = items.child[0];
  //   //      this.pageNo=0;
  //   //     this.total_pages=0;
  //   //     this.pageNo++;
  //   // this.selectedDocuments.clear();
  //   // this.selectAll=false;
  //   // this.getRFPDocuments();
  //   // }
  // }
  selectCompany(items: any) {
    // toggle: if already expanded, collapse; otherwise expand
    if (this.selectedParentRfpId === items['id']) {
      this.selectedParentRfpId = null;
      this.selectedCompanyId = null;
      this.selectedCompanyDetails = null;
      this.selectedRfp = null;
      this.documentListData = [];
      return;
    }

    this.selectedParentRfpId = items['id'];
    this.selectedCompanyId = items['id'];
    this.selectedCompanyDetails = items;
    this.selectedRfp = null;

    this.pageNo = 1;
    this.total_pages = 0;
    this.selectedDocuments.clear();
    this.selectAll = false;
    this.getRFPDocuments();
  }

  show(stepper: any) {
    // this.activeStep = stepper;
    //  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully', life: 3000 });
    this.notifier.notify('default', 'Created Successfully');
  }

  // deleteRFP(idx: number) {
  //   this.dialogService.openConfirmDialog('', {
  //     title: 'Confirm',
  //     message: 'Are you sure you want to delete this record?',
  //     btnOkText: 'Yes',
  //     btnCancelText: 'No',
  //     onClose: (data: any) => {
  //       if (data) {
  //         this.infosecService.deleteRFPtypes(idx).subscribe({
  //           next: (response: any) => {
  //             this.notifier.notify('default', 'Deleted Successfully');
  //             //this.getRFPtypesList();
  //           },
  //           error: (errors: HttpErrorResponse) => {},
  //         });
  //       }
  //     },
  //   });
  // }
  deleteRFP(idx: number) {
    // Find which parent owns this subcategory BEFORE deletion
    const parentCompany = this.companyListData.find((company: any) =>
      company.child?.some((sub: any) => sub.id === idx),
    );
    this.dialogService.openConfirmDialog('', {
      title: 'Confirm',
      message: 'Are you sure you want to delete this record?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          this.infosecService.deleteRFPtypes(idx).subscribe({
            next: (response: any) => {
              this.notifier.notify('default', 'Deleted Successfully');
              // this.getCompanyList();
              if (parentCompany) {
                // Navigate to the parent company after delete
                this.getCompanyListAndNavigate(
                  parentCompany.id,
                  parentCompany,
                  null,
                );
              } else {
                this.getCompanyList();
              }
            },
            error: (errors: HttpErrorResponse) => {},
          });
        }
      },
    });
  }

  getCompanyList() {
    this.infosecService.getCompanies().subscribe({
      next: (response: any) => {
        this.companyListData = response['result'];
        this.bodySpinner = false;
        if (this.companyListData.length > 0) {
          this.selectedCompanyId = this.companyListData[0]['id'];
          this.selectedCompanyDetails = this.companyListData[0];
          this.selectedParentRfpId = this.companyListData[0]['id'];
          this.selectedRfp = null;
          this.pageNo = 1;
          this.getRFPDocuments();
          //  if(this.companyListData[0].child.length > 0){
          //   this.selectedRfp=this.companyListData[0].child[0]['id'];
          //   this.selectedRfPDetails=this.companyListData[0].child[0];
          //   this.pageNo++;
          //   this.getRFPDocuments();
          //  }
        }
      },
      error: (errors: HttpErrorResponse) => {
        this.bodySpinner = false;
      },
    });
  }

  changeCompany(event: any) {
    console.log(event.target.value);
    this.selectedCompanyId = event.target.value;
  }

  // getRFPtypesList(){

  //      this.infosecService.getRFPtypesAll().subscribe(({
  //     next:(response:any)=>{
  //       this.bodySpinner=false;
  //        this.rfpList = response['result'];
  //        if(this.rfpList.length > 0){
  //          this.selectedList(this.rfpList[0]['id']);
  //        }
  //     },
  //     error:(errors:HttpErrorResponse)=>{
  //   this.bodySpinner=false;
  //     }
  //   }));

  // }

  // saveRfp() {
  //   this.submitted = true;
  //   this.rfpconfigFrom.value['client_id'] = this.client_id;
  //   this.rfpconfigFrom.value['company_id'] = this.selectedCompanyId;
  //   this.rfpconfigFrom.markAllAsTouched();
  //   this.rfpconfigFrom.markAsDirty();
  //   if (this.rfpconfigFrom.valid) {
  //     this.popLoader = true;
  //     this.infosecService.createRFPtypes(this.rfpconfigFrom.value).subscribe({
  //       next: (response: any) => {
  //         this.submitted = false;
  //         this.isModalVisible = false;
  //         this.rfpconfigFrom.reset();
  //         this.notifier.notify('default', 'created successfully');
  //         this.getCompanyList();
  //         // this.getRFPtypesList();
  //       },
  //       error: (errors: HttpErrorResponse) => {
  //         this.popLoader = false;
  //       },
  //     });
  //   }
  // }
  saveRfp() {
    this.submitted = true;
    this.rfpconfigFrom.value['client_id'] = this.client_id;
    this.rfpconfigFrom.value['company_id'] = this.selectedCompanyId;
    this.rfpconfigFrom.markAllAsTouched();
    this.rfpconfigFrom.markAsDirty();

    if (this.rfpconfigFrom.valid) {
      this.popLoader = true;
      this.rfpconfigFrom.patchValue({ is_active: true });

      const formValue = this.rfpconfigFrom.value;

      const payload = {
        client_id: this.client_id,
        company_id: this.selectedCompanyId,
        type_name: formValue.type_name,
        description: formValue.description,
        is_active: formValue.is_active,
      };
      const isSubfolder = !!this.selectedParentRfpId;
      const parentIdAtSave = this.selectedParentRfpId;

      if (isSubfolder) {
        // payload['parent_id'] = parentIdAtSave;
      }

      this.infosecService.createRFPtypes(payload).subscribe({
        next: (response: any) => {
          this.submitted = false;
          this.isModalVisible = false;
          this.rfpconfigFrom.reset();
          this.notifier.notify(
            'default',
            isSubfolder
              ? 'Subfolder created successfully'
              : 'Created successfully',
          );

          // Capture the context before getCompanyList resets it
          const targetParentId = parentIdAtSave;
          const targetCompanyDetails = this.selectedCompanyDetails;
          // The new subfolder id comes from the API response
          const newSubfolderId = response?.id ?? response?.data?.id ?? null;

          this.getCompanyListAndNavigate(
            targetParentId,
            targetCompanyDetails,
            newSubfolderId,
          );
        },
        error: (errors: HttpErrorResponse) => {
          this.popLoader = false;
        },
      });
    }
  }

  // editRFP(category: any) {
  //   this.showUpdateButton = true;
  //   this.selectedRfp = category?.id;
  //   this.rfpconfigFrom.patchValue(category);
  //   this.OpenModal('category');
  // }

  //   editRFP(category: any) {
  //   this.showUpdateButton = true;

  //   this.editingIsSubcategory = this.companyListData.some((parent: any) =>
  //     parent.child?.some((sub: any) => sub.id === category.id)
  //   );

  //   // Snapshot current selection before editing
  //   this._preEditSelectedRfp = this.selectedRfp;
  //   this._preEditSelectedRfPDetails = this.selectedRfPDetails;
  //   this._preEditParentRfpId = this.selectedParentRfpId;
  //   this._preEditParentRfpDetails = this.selectedParentRfpDetails;

  //   this.selectedRfp = category?.id;
  //   this.rfpconfigFrom.patchValue(category);
  //   this.OpenModal('category');
  // }
  editRFP(category: any) {
    this.showUpdateButton = true;

    // detect if it's a subfolder by checking companyListData children
    this.editingIsSubcategory = this.companyListData.some((parent: any) =>
      parent.child?.some((sub: any) => sub.id === category.id),
    );

    // snapshot current selection so Cancel can restore it
    this._preEditSelectedRfp = this.selectedRfp;
    this._preEditSelectedRfPDetails = this.selectedRfPDetails;
    this._preEditParentRfpId = this.selectedParentRfpId;
    this._preEditParentRfpDetails = this.selectedCompanyDetails;

    this.selectedRfp = category?.id;
    this.rfpconfigFrom.patchValue(category);
    this.OpenModal('category', 'edit');
  }

  // updateRFP() {
  //   this.submitted = true;
  //   this.rfpconfigFrom.value['client_id'] = this.client_id;
  //   this.rfpconfigFrom.markAllAsTouched();
  //   this.rfpconfigFrom.markAsDirty();
  //   if (this.rfpconfigFrom.valid) {
  //     this.popLoader = true;
  //     this.infosecService
  //       .updateRFPtypes(this.rfpconfigFrom.value, this.selectedRfp)
  //       .subscribe({
  //         next: (response: any) => {
  //           this.isModalVisible = false;
  //           this.notifier.notify('default', 'Category updated successfully');
  //           this.rfpconfigFrom.reset();
  //           // this.getRFPtypesList();
  //         },
  //         error: (errors: HttpErrorResponse) => {
  //           this.popLoader = false;
  //         },
  //       });
  //   }
  // }
  updateRFP() {
    this.submitted = true;
    this.rfpconfigFrom.value['client_id'] = this.client_id;
    this.rfpconfigFrom.markAllAsTouched();
    this.rfpconfigFrom.markAsDirty();

    if (this.rfpconfigFrom.valid) {
      this.popLoader = true;
      const previousSelectedRfp = this.selectedRfp;
      const previousParentId = this.selectedParentRfpId;
      this.rfpconfigFrom.patchValue({ is_active: true });

      const formValue = this.rfpconfigFrom.value;

      const payload = {
        client_id: this.client_id,
        company_id: this.selectedCompanyId,
        type_name: formValue.type_name,
        description: formValue.description,
        is_active: formValue.is_active,
      };
      this.infosecService.updateRFPtypes(payload, this.selectedRfp).subscribe({
        next: (response: any) => {
          this.isModalVisible = false;
          this.notifier.notify('default', 'Updated successfully');
          this.rfpconfigFrom.reset();
          this.showUpdateButton = false;
          this.editingIsSubcategory = false;
          // this.getCompanyList();
          this.popLoader = false;

          // Preserve the subfolder that was edited
          const targetParentId = previousParentId;
          const targetSubfolderId = previousSelectedRfp;

          this.getCompanyListAndNavigate(
            targetParentId,
            null,
            targetSubfolderId,
          );
        },
        error: (errors: HttpErrorResponse) => {
          this.popLoader = false;
        },
      });
    }
  }

  // uploadPopup(){
  //     this.uploadSelectFile=[];
  //     this.uploadFileForm.reset();
  //     this.editTrainId=null;
  //     this.excelSheetForm.reset();
  // }
  uploadPopup() {
    this.uploadSelectFile = [];
    this.uploadFileForm.reset();
    this.editTrainId = null;
    this.excelSheetForm.reset();
    this.showsheetform = false;
    this.sheetslist = [];
    this.isDragOver = false;
    this.fileLLMformData = new FormData();
    this.fileSheetMap = [];
    this.uploadFiletype = null;
    this._activeInputType = null; // ← reset
    this._isProcessingFiles = false; // ← reset in case stuck

    setTimeout(() => {
      if (this.excelFile?.nativeElement) {
        this.excelFile.nativeElement.value = '';
      }
      if (this.docFileInput?.nativeElement)
        this.docFileInput.nativeElement.value = '';
      if (this.xlsFileInput?.nativeElement)
        this.xlsFileInput.nativeElement.value = '';
    }, 0);
  }

  // chooseUploadFile(event:any) {

  //   /*
  //   const files = event.target.files;
  //     if (files[0].type == "application/pdf" || files[0].type=="text/plain" || files[0].type.indexOf("application/msword") != -1 || files[0].type.indexOf("application/vnd.openxmlformats") != -1 || files[0].type.indexOf("ms-excel") !=-1 || files[0].type.indexOf("application/vnd.openxmlformats-officedocument.wordprocessingml.document") !=-1) {

  //        const fileSizeInBytes = files[0].size;
  //   this.uploadSelectFile=files;
  //  console.log(files);
  //   console.log(`File size: ${fileSizeInBytes} bytes`);

  //   // Optional: Convert to KB or MB for better readability
  //   const fileSizeInKB = fileSizeInBytes / 1024;
  //   const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
  //   const fileSizeInGB = fileSizeInMB / (1024 * 1024 * 1024);
  //   console.log(`File size: ${fileSizeInKB.toFixed(2)} KB`);
  //   console.log(`File size: ${fileSizeInMB.toFixed(2)} MB`);
  //   console.log(`File size: ${fileSizeInGB.toFixed(2)} GB`);
  //   const file_gb = fileSizeInGB.toFixed(2);
  //   const size = file_gb.split(".")[1].substring(0, 1);
  //       this.fileLLMformData = new FormData();
  //       this.fileLLMformData.append('rfp_type_id',this.selectedRfp.toString());
  //        let d = new Date();
  //   var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
  //     d.getHours()+"-"+d.getMinutes()+"-"+d.getSeconds();
  //       this.fileLLMformData.append('file', files[0], datestring+"_"+files[0].name);

  //     }else{

  //       this.notifier.notify('default', 'File format not support');
  //       this.fileInput.nativeElement.value="";
  //       this.uploadSelectFile=[];
  //       this.uploadFileForm.setErrors({'invaid':true});
  //       return;
  //     }*/

  //        const files = event.target.files;
  //  console.log('files',files);
  //   if (files[0].type == "application/pdf" || files[0].type.indexOf("application/msword") != -1 || files[0].type.indexOf("document")!=-1 && files[0].type.indexOf("spreadsheetml") == -1){

  //     this.uploadFiletype="doc";

  //   }else if(files[0].type.indexOf("spreadsheetml") != -1 || files[0].type.indexOf("ms-excel") !=-1) {
  //          this.uploadFiletype="xls";
  //   }
  //  let fileLLMformData = new FormData();
  //  this.fileLLMformData = new FormData();
  //   let d = new Date();
  //   let datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
  //     d.getHours()+"-"+d.getMinutes()+"-"+d.getSeconds();
  //  fileLLMformData.append('file', files[0], files[0].name);
  //  this.fileLLMformData.append('file', files[0], files[0].name);
  //  fileLLMformData.append('client_id',this.client_id);
  //  fileLLMformData.append('metadata','null');
  //   this.uploadSelectFile=files;
  //     if(this.uploadFiletype == "xls") {
  //       this.popLoader=true;
  //       this.infosecService.uploadxls(fileLLMformData).subscribe({
  //         next:(response:any)=>{

  //         this.popLoader=false;
  //             this.sheetslist=[];
  //               this.sheetslist = response['sheets_names'];
  //             this.excelSheetForm.controls['file_name'].setValue(response['file_name']);

  //           this.generateSheetForm();
  //           this.showsheetform = true;

  //         },
  //         error:(errors:HttpErrorResponse)=>{
  //             this.bodySpinner=false;
  //             this.uploadSelectFile=[];
  //             this.popLoader=false;
  //             if(errors.error['errors']==400){
  //               this.notifier.notify("default","Unsupported File Format");
  //             }
  //         }
  //       });
  //     }
  //   }

  chooseUploadFile(event: any) {
    const input = event.target as HTMLInputElement;

    // Capture files into a plain array BEFORE resetting
    const files: File[] = Array.from(input.files || []);

    // Now safe to reset
    input.value = '';
    if (this.progressLoader) return; // ← guard

    if (files.length > 0) {
      this.processFiles(files);
    }
  }

  TrainRfp() {
    this.submitted = true;
    this.uploadFileForm.markAllAsTouched();
    this.uploadFileForm.markAsDirty();
    //  if(this.uploadFiletype==""){
    //    if(this.excelSheetForm.invalid){
    //       this.notifier.notify("default","Fill all required fields");
    //      return;
    //   }
    // }
    if (
      this.uploadFileForm.valid &&
      this.uploadSelectFile.length > 0 &&
      this.excelSheetForm.valid
    ) {
      this.submitted = false;
      this.popLoader = true;

      this.fileLLMformData = new FormData(); // reset

      // Append ALL selected files
      Array.from(this.uploadSelectFile).forEach((file: any) => {
        this.fileLLMformData.append('file', file, file.name);
      });

      // Use filename(s) as title if form title is blank
      const titleVal =
        this.uploadFileForm.value['title'] ||
        Array.from(this.uploadSelectFile)
          .map((f: any) => f.name)
          .join(', ');

      this.fileLLMformData.append('client_id', this.client_id);
      this.fileLLMformData.append('rfp_type_id', this.selectedRfp?.toString());
      this.fileLLMformData.append(
        'company',
        this.selectedCompanyId?.toString(),
      );

      if (this.editTrainId != null) {
        this.fileLLMformData.append('doc_id', this.editTrainId);
      }
      const sheetDetails = this.fileSheetMap.map((fileEntry) => {
        const formSheets = this.excelSheetForm.value['sheets']
          .filter((s: any) => s.file_name === fileEntry.file_name)
          .map((s: any) => ({
            sheet_name: s.sheet_name,
            question_column: s.question_column,
            answer_column: s.answer_column,
            starting_row: s.starting_row,
            comments_column: s.comments_column,
            attachment_column: s.attachment_column,
          }));

        return {
          file_name: fileEntry.file_name,
          sheets: formSheets,
        };
      });

      this.fileLLMformData.append(
        'sheet_details',
        JSON.stringify(sheetDetails),
      );

      this.progressLoader = true;
      if (this.editTrainId == null) {
        this.infosecService.trainRFPmodel(this.fileLLMformData).subscribe({
          next: (response: any) => {
            // this.messageService.add({severity:'success',detail:response['message'],life:3000});
            this.uploadSelectFile = [];
            //   let element =  document.getElementById("rfpTrain") as HTMLElement;
            // element.className="modal fade rfpTrainFormModal";
            // element.style.display="none";
            // document.getElementsByClassName("modal-backdrop")[0].remove();
            this.isModalVisible = false;
            this.notifier.notify('default', 'Trained Successfully');

            this.fileLLMformData = new FormData();
            this.sheetslist = [];
            this.excelSheetForm = this.fb.group({
              file_name: '',
              sheets: this.fb.array([]),
            });
            this.showsheetform = false;
            this.progressLoader = false;
            this.pageNo = 1;
            this.documentListData = [];
            this.getRFPDocuments();
          },
          error: (errors: HttpErrorResponse) => {
            this.progressLoader = false;
          },
        });
      } else {
        this.infosecService.updateTrainModel(this.fileLLMformData).subscribe({
          next: (response: any) => {
            this.uploadSelectFile = [];
            this.notifier.notify('default', 'Updated Successfully');
            this.fileLLMformData = new FormData();
            this.sheetslist = [];
            this.excelSheetForm = this.fb.group({
              file_name: '',
              sheets: this.fb.array([]),
            });
            this.showsheetform = false;
            this.progressLoader = false;
            this.popLoader = false;

            // properly close and fully reset modal state
            this.editTrainId = null;
            this.isModalVisible = false;
            this.submitted = false;
            this.uploadFiletype = null;
            this.fileSheetMap = [];
            this.isDragOver = false;
            this._activeInputType = null;
            this._isProcessingFiles = false;

            this.getRFPDocuments();
          },
          error: (errors: HttpErrorResponse) => {
            this.progressLoader = false;
            this.popLoader = false;
          },
        });
      }
    }
  }

  getRFPDocuments() {
    this.RFPDocPayLoad = {
      page: this.pageNo,
      per_page: this.limit,
      filters: [
        {
          property: 'meta:company_name',
          operator: 'eq',
          value: this.selectedCompanyId,
        },
      ],
    };
    if (this.selectedRfp != null) {
      let index = this.RFPDocPayLoad['filters'].findIndex(
        (list: any) => list['property'] == 'rfp_type_id',
      );
      if (index == -1) {
        this.RFPDocPayLoad['filters'].push({
          property: 'rfp_type_id',
          operator: 'eq',
          value: this.selectedRfp,
        });
      }
    }
    this.loading = true;
    this.bodySpinner = true;
    this.infosecService.getRFPDocuments(this.RFPDocPayLoad).subscribe({
      next: (response: any) => {
        this.bodySpinner = false;
        if (this.pageNo == 1) {
          this.documentListData =
            response['data'].length > 0 ? response['data'] : [];
        } else {
          if (response['data'].length > 0) {
            this.documentListData = [
              ...this.documentListData,
              ...response['data'],
            ];
          }
        }

        this.total_records = response['pagination']['total'];
        this.total_pages = response['pagination']['total_pages'];
        this.loading = false;
        this.selectAll = true;
        this.toggleSelectAll('single');
      },
      error: (errors: HttpErrorResponse) => {
        this.bodySpinner = false;
        this.documentListData = [];
        this.loading = false;
      },
    });
  }

  showSummary(document: any) {
    this.spinner = false;
    this.docSummary = {};
    this.docSummary['summary'] = document['metadata']['summary'];
    this.tabContent = 'summary';
    this.docSummary['detailed_summary'] = document?.metadata?.detailed_summary;
    this.docSummary['metadata_details'] = document?.metadata?.metadata_details;
    this.docSummary['rates_and_services'] =
      document?.metadata?.rates_and_services;
  }

  newCategory(modal: any) {
    this.submitted = false;
    this.seletedModal = modal;
    this.isModalVisible = true;
  }
  // exitIconReset() {
  //   this.docSummary = {};
  //   this.selectedFilePreview = '';
  //   this.uploadSelectFile = [];
  //   this.editTrainId = null;
  //   this.previewDocFileName = '';
  //   this.previewDocId = '';
  //   this.rfpconfigFrom.reset();
  //   this.isModalVisible = false;
  //   this.urlSafe = '';
  // }
  exitIconReset() {
    this.docSummary = {};
    this.selectedFilePreview = '';
    this.uploadSelectFile = [];
    this.editTrainId = null;
    this.previewDocFileName = '';
    this.previewDocId = '';
    this.rfpconfigFrom.reset();
    this.isModalVisible = false;
    this.urlSafe = '';

    // Restore prior selection if user cancelled edit
    if (this.showUpdateButton) {
      this.selectedRfp = this._preEditSelectedRfp;
      this.selectedRfPDetails = this._preEditSelectedRfPDetails;
      this.selectedParentRfpId = this._preEditParentRfpId;
      this.selectedParentRfpDetails = this._preEditParentRfpDetails;
    }

    this.showUpdateButton = false;
    this.editingIsSubcategory = false;
  }

  previewFile(document: any) {
    this.selectedFilePreview = '';
    // this.bodySpinner=true;
    this.urlSafe = '';
    this.spinner = true;
    this.metricFullscreen = true;
    this.previewFileType = document['doc_type'];
    this.previewDocFileName = document['doc_name'];
    this.previewDocId = document['id'];
    this.excelDataList = [];
    if (this.previewFileType == 'xls' || this.previewFileType == 'xlsx') {
      this.infosecService.getSheetsPrview(document['id']).subscribe({
        next: (response: any) => {
          // console.log("res",response);
          this.document_details['type'] = 'trained';
          if (document['sheet_details'] != null) {
            console.log(document['sheet_details']);
            this.sheetDetail = {
              file_name: this.previewDocFileName,
              sheets: document['sheet_details'],
            };
          } else {
            this.sheetDetail = {
              file_name: this.previewDocFileName,
              sheets: [
                {
                  sheet_name: 'Sheet1',
                  question_column: 'a',
                  answer_column: 'b',
                  starting_row: 2,
                  comments_column: '',
                  attachment_column: '',
                },
              ],
            };
          }

          this.dataExcel = response;
          console.log('res', response);
          if (Array.isArray(response)) {
            this.excelDataList = response;
          } else {
            if (Object.keys(response)) {
              let key = Object.keys(response)[0];
              this.excelDataList = response[key];
            }
          }
          this.bodySpinner = false;
          this.spinner = false;
        },
        error: (errors: HttpErrorResponse) => {
          this.bodySpinner = false;
          this.spinner = false;
        },
      });
    } else {
      this.urlSafe = '';
      this.infosecService.getDocumentPreview(document['id']).subscribe({
        next: (response: any) => {
          this.spinner = true;
          this.blobToBase64(response).then((res: any) => {
            // do what you wanna do
            this.urlSafe = res;
            this.spinner = false;
            this.bodySpinner = false;
          });
        },
        error: (errors: HttpErrorResponse) => {
          this.bodySpinner = false;
          this.spinner = false;
        },
      });
    }
  }

  viewDocumentFromBlob(blob: Blob) {
    // Create a blob URL
    // const pdfBlob = new Blob([blob], { type: 'application/pdf' });

    ///const objectUrl = URL.createObjectURL(pdfBlob);
    const objectUrl = URL.createObjectURL(blob);
    // Sanitize the URL before passing to ngx-doc-viewer
    this.spinner = false;
    this.selectedFilePreview =
      this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
  }

  deleteDocument(document: any) {
    this.dialogService.openConfirmDialog('', {
      title: 'Delete Document',
      message: 'Do you want to delete the file?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          this.spinner = true;

          this.infosecService.deleteTrainedDocument(document['id']).subscribe({
            next: (response: any) => {
              this.spinner = false;
              this.getRFPDocuments();
              // this.messageService.add({severity:'success',detail:'Document deleted successfully',life:3000});
              this.notifier.notify('default', 'Document deleted successfully');
            },
            error: (erors: HttpErrorResponse) => {
              this.spinner = false;
            },
          });
        }
      },
    });
  }

  contentLoaded() {}

  onNearEndScroll() {
    console.log('nearend');
    if (this.pageNo < this.total_pages) {
      this.pageNo++;
      this.getRFPDocuments();
    }
  }

  pageChanged(event: any) {
    this.pageNo = event;
  }

  keepOrder(x: KeyValue<string, any>, y: KeyValue<string, any>): number {
    return 1;
  }

  //  onTableScroll(event: any): void {
  //   const scrollTop = event.target.scrollTop;
  //   const scrollHeight = event.target.scrollHeight;
  //   const offsetHeight = event.target.offsetHeight;

  //   if (scrollHeight - (scrollTop + offsetHeight) < 50 && !this.loading) {
  //      console.log("more");
  //   }
  // }

  clickit($event: any, ind: any) {
    $event.stopPropagation();

    // Reset upward position if switching to a different dropdown
    if (this.dropdownIndex !== ind) {
      // this.dropdownUpIndex = -1;
    }

    this.dropdownIndex = ind;
    // this.show = !this.show;

    // // Check if dropdown should open upward
    // if (this.show) {
    //   // Use requestAnimationFrame to ensure DOM is updated
    //   requestAnimationFrame(() => {
    //     setTimeout(() => {
    //       this.checkDropdownPosition($event.target, ind);
    //     }, 10);
    //   });
    // } else {
    //   this.dropdownUpIndex = -1;
    // }
  }

  // dropdownUpIndex: number = -1; // Track which dropdown should open upward

  checkDropdownPosition(triggerElement: any, index: number) {
    // Find the dropdown container
    const dropdownContainer = triggerElement.closest('.dropdown');
    if (!dropdownContainer) return;

    const dropdownMenu = dropdownContainer.querySelector('.dropdown-menu');
    if (!dropdownMenu) return;

    const trigger = dropdownContainer.querySelector('.dropdown-trigger');
    if (!trigger) return;

    const triggerRect = trigger.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Get actual dropdown height if available, otherwise estimate
    const dropdownRect = dropdownMenu.getBoundingClientRect();
    const dropdownHeight = dropdownRect.height > 0 ? dropdownRect.height : 250;

    // Check if dropdown would be cut off at the bottom
    const spaceBelow = viewportHeight - triggerRect.bottom;

    // If not enough space below, open upward (with 10px buffer)
    if (spaceBelow < dropdownHeight + 10) {
      // this.dropdownUpIndex = index;
    } else {
      //this.dropdownUpIndex = -1;
    }
  }

  downloadFile(document: any) {
    let id = document['id'];
    this.infosecService.savefileDownload(id).subscribe({
      next: (response: any) => {
        let d = new Date();
        let datestring =
          d.getDate() +
          '-' +
          (d.getMonth() + 1) +
          '-' +
          d.getFullYear() +
          '_' +
          d.getHours();
        let doc_title = document?.title?.trim();
        importedSaveAs(response, doc_title);
        this.notifier.notify('default', 'File download successfully');
      },
      error: (errors: HttpErrorResponse) => {},
    });
  }

  // EditTraine(document: any) {
  //   if (this.selectedRfp) {
  //     this.submitted = false;
  //     this.uploadSelectFile = [];
  //     this.uploadFileForm.reset();
  //     this.editTrainId = null;
  //     this.excelSheetForm.reset();
  //     this.editTrainId = document['id'];
  //     this.uploadFileForm.controls['title'].setValue(document['title']);
  //     this.seletedModal = 'trainai';
  //     this.submitted = false;
  //     this.isModalVisible = true;
  //     this.popLoader = false;
  //   } else {
  //     this.notifier.notify(
  //       'default',
  //       'Please Select Folder to Upload Documents',
  //     );
  //   }
  // }

  EditTraine(document: any) {
    if (this.selectedRfp) {
      // Full reset first so stale state from a previous re-upload never lingers
      this.uploadPopup();

      this.editTrainId = document['id'];
      this.uploadFileForm.controls['title'].setValue(document['title']);
      this.seletedModal = 'trainai';
      this.submitted = false;
      this.isModalVisible = true;
      this.popLoader = false;
    } else {
      this.notifier.notify(
        'default',
        'Please Select Folder to Upload Documents',
      );
    }
  }

  onScrollExcel(event: any): void {}

  handleSave() {
    this.eventEmitter.next({ id: 'Source', type: 'save' });
    this.isEditing = false;
  }

  handleCancel() {
    this.eventEmitter.next({ id: 'Source', type: 'cancel' });
    this.isEditing = false;
  }

  onSave(event: any) {
    console.log(event);
    event['doc_id'] = this.previewDocId;
    event['file_name'] = this.previewDocFileName;
    event['client_id'] = this.client_id;
    if (event['action'] == 'updateTrain') {
      this.infosecService.editExcelTrain(event).subscribe({
        next: (response: any) => {
          this.getRFPDocuments();
          this.notifier.notify('default', 'Train AI Updated Successfully');
        },
        error: (errors: HttpErrorResponse) => {},
      });
    }
  }

  isDocumentSelected(document: any): boolean {
    const id = document['metadata'].document_id;
    return this.selectedDocuments.has(id);
  }

  toggleDocumentSelection(document: any) {
    const id = document['metadata'].document_id;

    if (id) {
      if (this.selectedDocuments.has(id)) {
        this.selectedDocuments.delete(id);
      } else {
        this.selectedDocuments.add(id);
      }
    }

    //this.updateSelectAllState();
  }

  toggleSelectAll(section: any) {
    this.documentSection = section;
    if (this.documentSection == 'all') {
      this.selectAll = false;
      if (this.selectAllDocument) {
        this.selectedDocuments.clear();
      } else {
        this.documentsAllList.forEach((doc) => {
          const id = doc['metadata'].document_id;
          if (id) {
            this.selectedDocuments.add(id);
          }
        });
      }
      this.selectAllDocument = !this.selectAllDocument;
    } else if (this.documentSection == 'single') {
      this.selectAllDocument = false;
      if (this.selectAll) {
        this.selectedDocuments.clear();
        this.documentListData.forEach((doc) => {
          const id = doc['metadata'].document_id;
          if (id) {
            this.selectedDocuments.add(id);
          }
        });
      } else {
        this.documentListData.forEach((doc) => {
          const id = doc['metadata'].document_id;
          if (id) {
            this.selectedDocuments.add(id);
          }
        });
      }
      // this.selectAll = !this.selectAll;
    }
  }

  generateSheetForm() {
    if (this.sheetslist.length > 0) {
      this.sheetslist.forEach((data: any, index) => {
        this.addSheets();
        this.Sheets.controls[index].get('sheet_name')?.setValue(data);
      });
    }
    //  let i = 0;

    //  while (i < this.sheetslist.length) {
    //   if(this.sheetslist[i]){
    //    this.addSheets();
    //    this.Sheets.controls[i].get('sheet_name')?.setValue(this.sheetslist[i]);
    //   }

    //    i++;
    //  }
  }

  get Sheets() {
    return this.excelSheetForm.get('sheets') as FormArray;
  }

  get sheetlist() {
    return this.sheetDataForm.get('sheet_list') as FormArray;
  }

  newSheet(): FormGroup {
    return this.fb.group({
      file_name: [''],
      sheet_name: ['', Validators.required],
      question_column: ['', Validators.required],
      answer_column: ['', Validators.required],
      starting_row: [1, Validators.required],
      comments_column: [''],
      attachment_column: [''],
    });
  }

  addSheets() {
    this.Sheets.push(this.newSheet());
  }

  // removeSheet(i: number) {
  //   this.Sheets.removeAt(i);
  //   if (this.Sheets.controls.length == 0) {
  //     this.showsheetform = false;
  //     this.uploadSelectFile = [];

  //     this.fileLLMformData.delete('file');
  //   }
  // }

  // removeSheet(i: number) {
  //   const removedSheetFileName = this.Sheets.at(i).get('file_name')?.value;

  //   this.Sheets.removeAt(i);

  //   const remainingForFile = this.Sheets.controls.filter(
  //     (ctrl) =>
  //       this.normalizeFileName(ctrl.get('file_name')?.value ?? '') ===
  //       this.normalizeFileName(removedSheetFileName ?? ''),
  //   );

  //   console.log(
  //     `removeSheet: file="${removedSheetFileName}", remaining sheets=${remainingForFile.length}`,
  //   );

  //   if (remainingForFile.length === 0 && removedSheetFileName) {
  //     const mapIndex = this.fileSheetMap.findIndex(
  //       (m) =>
  //         this.normalizeFileName(m.file_name) ===
  //         this.normalizeFileName(removedSheetFileName),
  //     );
  //     if (mapIndex !== -1) {
  //       this.fileSheetMap.splice(mapIndex, 1);
  //     }

  //     const fileIndex = (this.uploadSelectFile as File[]).findIndex(
  //       (f) =>
  //         this.normalizeFileName(f.name) ===
  //         this.normalizeFileName(removedSheetFileName),
  //     );
  //     if (fileIndex !== -1) {
  //       (this.uploadSelectFile as File[]).splice(fileIndex, 1);
  //     }

  //     console.log(
  //       `Removed from map and chips. Remaining fileSheetMap:`,
  //       this.fileSheetMap.map((m) => m.file_name),
  //     );
  //   }

  //   if (this.Sheets.controls.length === 0) {
  //     this.showsheetform = false;
  //     this.fileSheetMap = [];
  //     this.uploadSelectFile = [];
  //     this.uploadFiletype = null;
  //     this.fileLLMformData = new FormData();
  //   }
  // }

  removeSheet(i: number) {
    const removedSheetName = this.Sheets.at(i).get('sheet_name')?.value;
    const removedSheetFileName = this.Sheets.at(i).get('file_name')?.value;

    this.Sheets.removeAt(i);

    // ✅ Sync the sheet out of fileSheetMap for that specific file
    const mapEntry = this.fileSheetMap.find(
      (m) =>
        this.normalizeFileName(m.file_name) ===
        this.normalizeFileName(removedSheetFileName ?? ''),
    );

    if (mapEntry) {
      mapEntry.sheets = mapEntry.sheets.filter(
        (s: any) =>
          this.normalizeFileName(s.sheet_name) !==
          this.normalizeFileName(removedSheetName ?? ''),
      );

      // If no sheets remain for this file, remove the whole file entry
      if (mapEntry.sheets.length === 0) {
        const mapIndex = this.fileSheetMap.findIndex(
          (m) =>
            this.normalizeFileName(m.file_name) ===
            this.normalizeFileName(removedSheetFileName ?? ''),
        );
        if (mapIndex !== -1) this.fileSheetMap.splice(mapIndex, 1);

        const fileIndex = (this.uploadSelectFile as File[]).findIndex(
          (f) =>
            this.normalizeFileName(f.name) ===
            this.normalizeFileName(removedSheetFileName ?? ''),
        );
        if (fileIndex !== -1)
          (this.uploadSelectFile as File[]).splice(fileIndex, 1);
      }
    }

    if (this.Sheets.controls.length === 0) {
      this.showsheetform = false;
      this.fileSheetMap = [];
      this.uploadSelectFile = [];
      this.uploadFiletype = null;
      this.fileLLMformData = new FormData();
    }
  }

  // OpenModal(modal: any) {
  //   // Only validate selectedRfp when modal is "trainai"
  //   if (modal === 'trainai' && !this.selectedRfp) {
  //     this.notifier.notify(
  //       'default',
  //       'Please Select Folder to Upload Documents',
  //     );
  //     return;
  //   }

  //   this.seletedModal = modal;

  //   if (modal === 'trainai') {
  //     this.uploadPopup();
  //   }

  //   this.submitted = false;
  //   this.isModalVisible = true;
  //   this.popLoader = false;
  // }
  // CHANGE this:

  // OpenModal(modal: any, type?: string, parentItem?: any): any {
  //   this.seletedModal = modal;

  //   if (modal === 'trainai') {
  //     if (!this.selectedRfp) {
  //       this.notifier.notify('default', 'Please Select Folder to Upload Documents');
  //       return;
  //     }
  //     this.uploadPopup();
  //   }

  //   this.submitted = false;
  //   this.isModalVisible = true;
  //   this.popLoader = false;

  //   if (type === 'new') {
  //     this.editTrainId = null;
  //     this.rfpconfigFrom.reset();
  //     this.rfpconfigFrom.patchValue({ is_active: true });
  //     this.showUpdateButton = false;
  //   }

  //   if (parentItem) {
  //     this.selectedParentRfpId = parentItem.id;
  //     this.selectedParentRfpDetails = parentItem;
  //   } else if (type === 'new' && modal === 'category') {
  //     this.selectedParentRfpId = null;
  //     this.selectedParentRfpDetails = null;
  //   }
  // }

  OpenModal(modal: any, type?: string, parentItem?: any): any {
    this.seletedModal = modal;

    if (modal === 'trainai') {
      if (!this.selectedRfp) {
        this.notifier.notify(
          'default',
          'Please Select Folder to Upload Documents',
        );
        return;
      }
      this.uploadPopup();
    }

    if (modal === 'category') {
      if (type === 'new') {
        this.showUpdateButton = false;
        this.editTrainId = null;
        this.rfpconfigFrom.reset();
        this.rfpconfigFrom.patchValue({ is_active: true });

        if (parentItem) {
          // adding a subfolder under parentItem
          this.selectedParentRfpId = parentItem.id;
          this.selectedCompanyDetails = parentItem;
        } else {
          // adding a root category — clear parent context
          this.selectedParentRfpId = null;
          this.selectedCompanyDetails = null;
        }
      }
    }

    this.submitted = false;
    this.isModalVisible = true;
    this.popLoader = false;
  }

  changeTobot() {
    this.botEnabled = !this.botEnabled;
    this.botExpand = false;
    this.getAllDocumentsList();
    if (this.botEnabled) {
      this.queryType = 'private';
      this.botQAList = [];
      this.selectedDocuments.clear();
      this.selectAll = true;
      this.toggleSelectAll('single');
      this.pageNo = 1;
      this.limit = 25;
      this.historyPayload = {
        client_id: this.client_id,
        page: this.pageNo,
        limit: this.limit,
        filters: [],
      };
      this.pinPayload = {
        client_id: this.client_id,
        page: this.pageNo,
        limit: this.limit,
        filters: [
          {
            property: 'is_pinned',
            operator: 'eq',
            value: true,
          },
        ],
      };
      this.getBotQueryAll();
      this.getBotQueryPinAll();
    }
  }

  expandBot() {
    this.botExpand = !this.botExpand;
  }

  searchQuery(data: any) {
    if (data['tags'].length == 0 && data['data'] == '') {
      this.notifier.notify('default', 'Enter your question');
      return;
    }

    if (this.selectedDocuments.size == 0 && this.queryType == 'private') {
      this.notifier.notify(
        'default',
        'No documents in ' + this.selectedRfPDetails?.type_name,
      );
      return;
    }

    if (data['data'].trim() != '') {
      data['tags'].push(data['data']);
    }

    let payLoad: any;

    if (this.queryType == 'private') {
      payLoad = {
        document_id: Array.from(this.selectedDocuments).toString(),
        question: data['tags'],
        mode: 'answer',
        client_id: this.client_id,
        category_id: this.selectedRfp,
        company: this.selectedCompanyId,
        query_type: this.queryType,
        is_global: false,
      };
    } else {
      payLoad = {
        question: data['tags'],
        client_id: this.client_id,
        query_type: this.queryType,
        is_global: false,
      };
    }

    //this.bodySpinner=true;
    this.ProgressLoader.showLoader('', { loaderMessage: 'In-Progress' });
    this.infosecService.searchBotQuery(payLoad).subscribe({
      next: (response: any) => {
        // this.bodySpinner=false;
        this.ProgressLoader.closeLoader();
        this.botQAList = [...response, ...this.botQAList];
      },
      error: (errors: HttpErrorResponse) => {
        // this.bodySpinner=false;
        this.ProgressLoader.closeLoader();
      },
    });
  }

  getBotQueryAll() {
    this.spinner = true;
    this.infosecService.getBotQueryAll(this.historyPayload).subscribe({
      next: (response: any) => {
        this.spinner = false;
        if (response['data'].length > 0) {
          this.historyTotalRecords = response['pagination']['total_records'];
          if (this.historyPayload['page'] == 1) {
            this.botQAList = response['data'];
          } else {
            this.botQAList = [...this.botQAList, ...response['data']];
          }
        }
      },
      error: (errors: HttpErrorResponse) => {
        this.spinner = false;
      },
    });
  }
  onScrollBotQuery() {
    if (this.historyTotalRecords > this.botQAList.length) {
      this.historyPayload['page'] = this.historyPayload['page'] + 1;
      this.getBotQueryAll();
    }
  }

  showTools(content: any) {
    this.tabContent = content;
    if (content) {
      this.showToolspopUp = true;
    } else {
      this.showToolspopUp = false;
    }
    if (content == 'pin') {
      if (this.botQAPinnedList.length > 0) {
        this.selectedPinRecord = this.botQAPinnedList[0];
      }
    }

    if (content == 'files') {
      this.pageNo = 1;
      this.getBotQueryFiles();
    }
    if (content == 'audio') {
      this.pageNo = 1;
      this.botQAFilespayload = {
        client_id: this.client_id,
        page: this.pageNo,
        limit: this.limit,
        filters: [
          {
            property: 'is_mp3',
            operator: 'eq',
            value: true,
          },
        ],
      };

      this.getBotQueryAudioFiles();
    }
  }

  deleteQuery(list: any) {
    let qId = list['qid'];
    this.dialogService.openConfirmDialog('', {
      title: 'Confirm',
      message: 'Are you sure you want to delete this record?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          //this.ProgressLoader.showLoader('',{loaderMessage:"Progress"});
          this.infosecService.botQueryDelete(qId).subscribe({
            next: (response: any) => {
              // this.ProgressLoader.closeLoader();
              let index = this.botQAList.findIndex(
                (list: any) => list['qid'] == qId,
              );
              if (index != -1) {
                this.botQAList.splice(index, 1);
                this.notifier.notify('default', 'Deleted Successfully');
              }
            },
            error: (errors: HttpErrorResponse) => {
              // this.ProgressLoader.closeLoader();
            },
          });
        }
      },
    });
  }

  botToolsAction(data: any) {
    let qid = data['qid'];
    if (data['action'] == 'pin') {
      this.infosecService.botQueryPin(qid).subscribe({
        next: (response: any) => {
          let index = this.botQAList.findIndex(
            (list: any) => list['qid'] == qid,
          );
          if (index != -1) {
            this.botQAList[index]['is_pinned'] = true;
            this.botQAPinnedList.unshift(this.botQAList[index]);
          }
          this.notifier.notify('default', 'Pinned Successfully');
        },
        error: (errors: HttpErrorResponse) => {},
      });
    } else if (data['action'] == 'file') {
      this.isFileGenModalVisible = true;
      this.botQAgenFile = null;
      this.botQAGenFilePayLoad = {
        client_id: this.client_id,
        qid: qid,
      };
    } else if (data['action'] == 'audio') {
      this.botQAGenFilePayLoad = {
        client_id: this.client_id,
        qid: qid,
        is_mp3: true,
      };
      this.infosecService.botQueryGenfile(this.botQAGenFilePayLoad).subscribe({
        next: (response: any) => {
          this.notifier.notify('default', 'File generated successfully');
        },
        error: (errors: HttpErrorResponse) => {},
      });
    } else if (data['action'] == 'comment') {
      data['client_id'] = this.client_id;
      this.infosecService.botQueryComment(data).subscribe({
        next: (response: any) => {
          this.notifier.notify('default', 'Your comment posted successfully');
        },
        error: (errors: HttpErrorResponse) => {},
      });
    }
  }

  getBotQueryPinAll() {
    this.infosecService.getBotQueryPinAll(this.pinPayload).subscribe({
      next: (response: any) => {
        if (response['data'].length > 0) {
          this.pinnedTotalRecords = response['pagination']['total_records'];
          if (this.pinPayload['page'] == 1) {
            this.botQAPinnedList = response['data'];
          } else {
            this.botQAPinnedList = [
              ...this.botQAPinnedList,
              ...response['data'],
            ];
          }
        }
      },
      error: (errors: HttpErrorResponse) => {},
    });
  }

  onScrollPinned() {
    if (this.pinnedTotalRecords > this.botQAPinnedList.length) {
      this.pinPayload['page'] = this.pinPayload['page'] + 1;
      this.getBotQueryPinAll();
    }
  }

  unPinnedQuery(item: any) {
    let qid = item['qid'];
    this.dialogService.openConfirmDialog('', {
      title: 'Confirm',
      message: 'Are you sure you want to UnPin this record?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          this.infosecService.botQueryUnPin(qid).subscribe({
            next: (response: any) => {
              let index = this.botQAPinnedList.findIndex(
                (list: any) => list['qid'] == qid,
              );
              if (index != -1) {
                this.botQAPinnedList.splice(index, 1);
                let unPinindex = this.botQAList.findIndex(
                  (list: any) => list['qid'] == qid,
                );
                if (unPinindex != -1) {
                  this.botQAList[unPinindex]['is_pinned'] = false;
                }
                this.notifier.notify('default', 'Unpinned Successfully');
                if (this.botQAPinnedList.length > 0) {
                  this.selectedPinRecord = this.botQAPinnedList[0];
                } else {
                  this.selectedPinRecord = '';
                }
              }
            },
            error: (errors: HttpErrorResponse) => {},
          });
        }
      },
    });
  }

  gotoBotQA(questionId: any) {
    this.showToolspopUp = false;
    this.tabContent = '';
    var isScrolling: any;
    setTimeout(() => {
      const element = document.getElementById('question' + questionId);
      element?.scrollIntoView({ behavior: 'smooth' });
      document.getElementsByClassName('internalBodyTwo')[0].scrollTop = 0;
      (
        this.document.getElementById('chat-list-content') as HTMLElement
      ).addEventListener('scroll', (ev: any) => {
        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);
        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function () {
          document.getElementsByClassName('internalBodyTwo')[0].scrollTop = 0;
          // Run the callback
        }, 100);
      });
    }, 10);
  }

  getBotQueryFiles() {
    this.botQAFilespayload = {
      client_id: this.client_id,
      page: this.pageNo,
      limit: this.limit,
      filters: [
        {
          property: 'is_docx',
          operator: 'eq',
          value: true,
        },
        {
          property: 'is_pdf',
          operator: 'eq',
          value: true,
        },
      ],
    };

    this.infosecService.getBotQueryAll(this.botQAFilespayload).subscribe({
      next: (response: any) => {
        this.botQAFileList = response['data'];

        if (response['data'].length > 0) {
          this.botFilesTotalRecords = response['pagination']['total_records'];
          if (this.pinPayload['page'] == 1) {
            this.botQAFileList = response['data'];

            this.showQABotfile(this.botQAFileList[0], 0);
          } else {
            this.botQAFileList = [...response['data'], ...this.botQAFileList];
          }
        }
      },
      error: (errors: HttpErrorResponse) => {},
    });
  }
  onScrollGenFiles() {
    if (this.tabContent == 'files') {
      if (this.botFilesTotalRecords > this.botQAFileList.length) {
        this.botQAFilespayload['page'] = this.botQAFilespayload['page'] + 1;
        this.getBotQueryFiles();
      }
    }

    if (this.tabContent == 'audio') {
      if (this.botAudioFilesTotalRecords > this.botQAAudioFileList.length) {
        this.botQAFilespayload['page'] = this.botQAFilespayload['page'] + 1;
        this.getBotQueryAudioFiles();
      }
    }
  }

  getBotQueryAudioFiles() {
    this.infosecService.getBotQueryAll(this.botQAFilespayload).subscribe({
      next: (response: any) => {
        if (response['data'].length > 0) {
          this.botFilesTotalRecords = response['pagination']['total_records'];
          if (this.botQAFilespayload['page'] == 1) {
            this.botQAAudioFileList = response['data'];

            this.showQABotfile(this.botQAAudioFileList[0], 0);
          } else {
            this.botQAAudioFileList = [
              ...response['data'],
              ...this.botQAAudioFileList,
            ];
          }
        }
      },
      error: (errors: HttpErrorResponse) => {},
    });
  }

  selectFileType(data: any) {
    this.botQAgenFile = data;
  }
  genFileTypeSubmit() {
    if (this.botQAgenFile != null) {
      if (this.botQAgenFile == 'docx') {
        this.botQAGenFilePayLoad['is_docx'] = true;
      } else if (this.botQAgenFile == 'pdf') {
        this.botQAGenFilePayLoad['is_pdf'] = true;
      }

      this.infosecService.botQueryGenfile(this.botQAGenFilePayLoad).subscribe({
        next: (response: any) => {
          this.isFileGenModalVisible = false;
          this.notifier.notify('default', 'File generated successfully');
        },
        error: (errors: HttpErrorResponse) => {},
      });
    }
  }

  showQABotfile(data: any, index: any) {
    let payload = {
      client_id: this.client_id,
      qid: data['qid'],
      doc_type: data['doc_type'] == 'mp3' ? 'mp3' : 'pdf',
    };
    this.selectedPinRecord['select_index'] = index;
    this.loader = true;
    this.infosecService.botQueryFilePreview(payload).subscribe({
      next: (response: any) => {
        this.urlSafe = '';
        this.blobToBase64(response).then((res: any) => {
          this.urlSafe = res;
          this.loader = false;
        });
      },
      error: (errors: HttpErrorResponse) => {
        this.loader = false;
      },
    });
  }

  blobToBase64(blob: any) {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve, reject) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  }

  removeFile(item: any) {
    let payload = {
      qid: item['qid'],
      doc_type: item['doc_type'],
    };
    this.dialogService.openConfirmDialog('', {
      title: 'Confirm',
      message: 'Are you sure you want to delete this record?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          this.infosecService.botQueryFileDelete(payload).subscribe({
            next: (response: any) => {
              this.notifier.notify('default', 'Deleted Successfully');
              if (this.tabContent == 'files') {
                let index = this.botQAFileList.findIndex(
                  (list: any) => list['qid'] == item['qid'],
                );
                if (index != -1) {
                  this.botQAFileList.splice(index, 1);
                }
              }
              if (this.tabContent == 'audio') {
                let index = this.botQAAudioFileList.findIndex(
                  (list: any) => list['qid'] == item['qid'],
                );
                if (index != -1) {
                  this.botQAAudioFileList.splice(index, 1);
                  if (this.botQAAudioFileList.length == 0) {
                    this.urlSafe = '';
                  }
                }
              }
            },
            error: (errors: HttpErrorResponse) => {},
          });
        }
      },
    });
  }

  downloadfile(item: any) {
    let payload = {
      client_id: this.client_id,
      qid: item['qid'],
      doc_type: item['doc_type'],
    };

    this.infosecService.botQueryFilePreview(payload).subscribe({
      next: (response: any) => {
        let d = new Date();
        var datestring =
          d.getDate() +
          '-' +
          (d.getMonth() + 1) +
          '-' +
          d.getFullYear() +
          '_' +
          d.getHours();
        let doc_title = document?.title?.trim();
        importedSaveAs(response, doc_title + '.' + item['doc_type']);
        this.notifier.notify('default', 'File download successfully');
      },
      error: (errors: HttpErrorResponse) => {},
    });
  }

  selectQueryType(type: any) {
    this.queryType = type;
  }

  getAllDocumentsList() {
    this.documentsAllList = [];
    let PayLoad = {
      page: 1,
      per_page: 1000,
      filters: [],
    };

    this.infosecService.getRFPDocuments(PayLoad).subscribe({
      next: (response: any) => {
        this.documentsAllList =
          response['data'].length > 0 ? response['data'] : [];
      },
      error: (errors: HttpErrorResponse) => {
        this.documentsAllList = [];
      },
    });
  }

  selectDocSection(section: any) {
    this.documentSection = section;
  }

  showTab(tabContent: any) {
    this.tabContent = tabContent;
  }

  onModelClose(): void {
    this.isModalVisible = !this.isModalVisible;
    this.Sheets.clear();
    this.showsheetform = false;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    if (this.progressLoader) return;
    if (this.editTrainId != null) {
      this.notifier.notify(
        'default',
        'Use the file button to select a replacement file.',
      );
      return;
    }
    this._activeInputType = null;
    const files = event.dataTransfer?.files;
    if (files) this.processFiles(Array.from(files));
  }

  // removeSelectedFile(index: number) {
  //   const arr = Array.from(this.uploadSelectFile) as File[];
  //   const removedFile = arr[index];
  //   arr.splice(index, 1);
  //   this.uploadSelectFile = arr;

  //   const mapIndex = this.fileSheetMap.findIndex(
  //     (m) => m.file_name === removedFile.name,
  //   );
  //   if (mapIndex !== -1) {
  //     this.fileSheetMap.splice(mapIndex, 1);
  //     this.rebuildSheetForm();
  //   }

  //   if (arr.length === 0) {
  //     this.fileLLMformData = new FormData();
  //     this.showsheetform = false;
  //     this.fileSheetMap = [];
  //     this.uploadFiletype = null; // ← reset type so next upload can be any type
  //   }
  // }
  removeSelectedFile(index: number) {
    const arr = Array.from(this.uploadSelectFile) as File[];
    const removedFile = arr[index];
    arr.splice(index, 1);
    this.uploadSelectFile = arr;

    // Use normalized compare to handle space vs underscore
    const mapIndex = this.fileSheetMap.findIndex(
      (m) =>
        this.normalizeFileName(m.file_name) ===
        this.normalizeFileName(removedFile.name),
    );

    console.log(
      `Removing file: "${removedFile.name}", normalized: "${this.normalizeFileName(removedFile.name)}"`,
    );
    console.log(
      `fileSheetMap keys normalized:`,
      this.fileSheetMap.map((m) => this.normalizeFileName(m.file_name)),
    );
    console.log(`findIndex result: ${mapIndex}`);

    if (mapIndex !== -1) {
      this.fileSheetMap.splice(mapIndex, 1);
    }

    this.rebuildSheetForm();

    if (this.fileSheetMap.length === 0) {
      this.showsheetform = false;
      this.uploadFiletype = null;
    }

    if (arr.length === 0) {
      this.fileLLMformData = new FormData();
      this.fileSheetMap = [];
      this.showsheetform = false;
      this.uploadFiletype = null;
    }
  }

  // processFiles(files: File[]) {
  //     const allowedTypes = [
  //         'application/pdf',
  //         'application/msword',
  //         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  //         'application/vnd.ms-excel',
  //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //         'text/plain'
  //     ];
  //     const validFiles = files.filter(file => {
  //         const isValid = allowedTypes.some(type => file.type === type)
  //                      || file.type.indexOf('spreadsheetml') !== -1
  //                      || file.type.indexOf('ms-excel') !== -1;
  //         if (!isValid) {
  //             this.notifier.notify('default', `"${file.name}" — unsupported format, skipped`);
  //         }
  //         return isValid;
  //     });
  //     if (validFiles.length === 0) return;
  //     const existing: File[] = Array.from(this.uploadSelectFile);
  //     validFiles.forEach(f => {
  //         if (!existing.find(e => e.name === f.name)) {
  //             existing.push(f);
  //         } else {
  //             this.notifier.notify('default', `"${f.name}" already added, skipped`);
  //         }
  //     });
  //     this.uploadSelectFile = existing;
  //     // Process each Excel file separately
  //     const xlsFiles = validFiles.filter(f =>
  //         f.type.indexOf('spreadsheetml') !== -1 || f.type.indexOf('ms-excel') !== -1
  //     );

  //     if (xlsFiles.length > 0) {
  //         this.uploadFiletype = 'xls';
  //         xlsFiles.forEach(xlsFile => {
  //             // Skip if already processed
  //             if (this.fileSheetMap.find(m => m.file_name === xlsFile.name)) return;
  //             const formData = new FormData();
  //             formData.append('file', xlsFile, xlsFile.name);
  //             formData.append('client_id', this.client_id);
  //             formData.append('metadata', 'null');
  //             this.popLoader = true;

  //             this.infosecService.uploadxls(formData).subscribe({
  //                 next: (response: any) => {
  //                     this.popLoader = false;
  //                     // Add entry to fileSheetMap for this file
  //                     this.fileSheetMap.push({
  //                         file_name: xlsFile.name,
  //                         file: xlsFile,
  //                         sheets: response['sheets_names'].map((sheetName: string) => ({
  //                             sheet_name: sheetName,
  //                             question_column: '',
  //                             answer_column: '',
  //                             starting_row: 1,
  //                             comments_column: '',
  //                             attachment_column: ''
  //                         }))
  //                     });

  //                     this.rebuildSheetForm();
  //                     this.showsheetform = true;
  //                 },
  //                 error: (errors: HttpErrorResponse) => {
  //                     this.popLoader = false;
  //                     this.notifier.notify('default', 'Unsupported file format');
  //                 }
  //             });
  //         });
  //     } else {
  //         this.uploadFiletype = 'doc';
  //     }
  // }

  processFiles(files: File[]) {
    if (this._isProcessingFiles) return;
    this._isProcessingFiles = true;

    // const allowedTypes = [
    //   'application/pdf',
    //   'application/msword',
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    //   'application/vnd.ms-excel',
    //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //   'application/vnd.ms-excel.sheet.macroEnabled.12',
    //   'text/plain',
    // ];

    // const validFiles = files.filter((file) => {
    //   const isValid =
    //     allowedTypes.some((t) => file.type === t) ||
    //     file.type.indexOf('spreadsheetml') !== -1 ||
    //     file.type.indexOf('ms-excel') !== -1;
    //   if (!isValid)
    //     this.notifier.notify(
    //       'default',
    //       `"${file.name}" — unsupported format, skipped`,
    //     );
    //   return isValid;
    // });

    const allowedExtensions = [
      'pdf',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'xlsm',
      'txt',
    ];

    const getExtension = (f: File) =>
      f.name.split('.').pop()?.toLowerCase() ?? '';

    const validFiles = files.filter((file) => {
      const isValid = allowedExtensions.includes(getExtension(file));
      if (!isValid)
        this.notifier.notify(
          'default',
          `"${file.name}" — unsupported format, skipped`,
        );
      return isValid;
    });

    if (validFiles.length === 0) {
      this._isProcessingFiles = false;
      return;
    }

    const MAX_FILES = 10;
    // Re-upload mode: only one file allowed
    if (this.editTrainId != null) {
      if (validFiles.length > 1) {
        this.notifier.notify(
          'default',
          'Re-upload allows only one file at a time.',
        );
        this._isProcessingFiles = false;
        return;
      }
      // Replace existing selection entirely
      this.uploadSelectFile = [];
      this.fileSheetMap = [];
      this.Sheets.clear();
      this.showsheetform = false;
    }
    if (this.uploadSelectFile.length + validFiles.length > MAX_FILES) {
      this.notifier.notify('default', `Maximum ${MAX_FILES} files allowed.`);
      this._isProcessingFiles = false;
      return;
    }

    // const isExcel = (f: File) =>
    //   f.type.indexOf('spreadsheetml') !== -1 ||
    //   f.type.indexOf('ms-excel') !== -1 ||
    //   /\.(xls|xlsx|xlsm)$/i.test(f.name);
    const isExcel = (f: File) =>
      ['xls', 'xlsx', 'xlsm'].includes(getExtension(f));
    const incomingType = isExcel(validFiles[0]) ? 'xls' : 'doc';

    if (
      this.uploadSelectFile.length > 0 &&
      this.uploadFiletype !== null &&
      this.uploadFiletype !== incomingType
    ) {
      const label = this.uploadFiletype === 'xls' ? 'Excel' : 'PDF/DOC';
      this.notifier.notify(
        'default',
        `Only ${label} files allowed. Remove existing files to switch type.`,
      );
      this._isProcessingFiles = false;
      return;
    }

    if (validFiles.some((f) => isExcel(f) !== (incomingType === 'xls'))) {
      this.notifier.notify(
        'default',
        'Please select files of the same type (all Excel or all PDF/DOC).',
      );
      this._isProcessingFiles = false;
      return;
    }

    // Build new unique file list
    const existing: File[] = [...(this.uploadSelectFile as File[])];
    const newUniqueFiles: File[] = [];

    validFiles.forEach((f) => {
      const alreadyInList = existing.some(
        (e) =>
          this.normalizeFileName(e.name) === this.normalizeFileName(f.name),
      );
      if (!alreadyInList) {
        existing.push(f);
        newUniqueFiles.push(f);
      } else {
        this.notifier.notify('default', `"${f.name}" already added, skipped`);
      }
    });

    if (newUniqueFiles.length === 0) {
      this._isProcessingFiles = false;
      return;
    }

    // Commit to uploadSelectFile only once, with deduped list
    this.uploadSelectFile = existing;

    if (incomingType === 'xls') {
      this.uploadFiletype = 'xls';

      const newFiles = newUniqueFiles.filter(
        (f) =>
          !this.fileSheetMap.find(
            (m) =>
              this.normalizeFileName(m.file_name) ===
              this.normalizeFileName(f.name),
          ),
      );

      if (newFiles.length === 0) {
        this._isProcessingFiles = false;
        return;
      }

      const formData = new FormData();
      newFiles.forEach((f) => formData.append('file', f, f.name));
      formData.append('client_id', this.client_id);
      formData.append('metadata', 'null');
      this.popLoader = true;

      this.infosecService.extractKbSheet(formData).subscribe({
        next: (response: any[]) => {
          this.popLoader = false;
          response.forEach((fileResponse) => {
            const matchedFile = newFiles.find(
              (f) =>
                this.normalizeFileName(f.name) ===
                this.normalizeFileName(fileResponse.file_name),
            );
            if (
              this.fileSheetMap.find(
                (m) =>
                  this.normalizeFileName(m.file_name) ===
                  this.normalizeFileName(fileResponse.file_name),
              )
            )
              return;

            this.fileSheetMap.push({
              file_name: matchedFile?.name ?? fileResponse.file_name,
              file: matchedFile as File,
              sheets: fileResponse.sheets_names.map((sheetName: string) => ({
                sheet_name: sheetName,
                question_column: '',
                answer_column: '',
                starting_row: 1,
                comments_column: '',
                attachment_column: '',
              })),
            });
          });
          this.rebuildSheetForm();
          this.showsheetform = true;
          this._isProcessingFiles = false;
        },
        error: () => {
          this.popLoader = false;
          this._isProcessingFiles = false;
        },
      });
    } else {
      this.uploadFiletype = 'doc';
      this._isProcessingFiles = false;
    }
  }

  // rebuildSheetForm() {
  //   // Clear existing sheets
  //   while (this.Sheets.length) {
  //     this.Sheets.removeAt(0);
  //   }

  //   console.log(
  //     'Rebuilding sheet form from fileSheetMap:',
  //     JSON.stringify(this.fileSheetMap.map((m) => m.file_name)),
  //   );

  //   // Rebuild from fileSheetMap
  //   this.fileSheetMap.forEach((fileEntry) => {
  //     fileEntry.sheets.forEach((sheet: any) => {
  //       const group = this.fb.group({
  //         file_name: [fileEntry.file_name],
  //         sheet_name: [sheet.sheet_name, Validators.required],
  //         question_column: [sheet.question_column, Validators.required],
  //         answer_column: [sheet.answer_column, Validators.required],
  //         starting_row: [sheet.starting_row, Validators.required],
  //         comments_column: [sheet.comments_column],
  //         attachment_column: [sheet.attachment_column],
  //       });
  //       this.Sheets.push(group);
  //     });
  //   });
  //   console.log(
  //     'Sheet form values after rebuild:',
  //     JSON.stringify(
  //       this.Sheets.controls.map((c) => c.get('file_name')?.value),
  //     ),
  //   );
  // }

  rebuildSheetForm() {
    // Snapshot current form values BEFORE clearing
    const currentValues: { [key: string]: any } = {};
    this.Sheets.controls.forEach((ctrl) => {
      const fileName = ctrl.get('file_name')?.value ?? '';
      const sheetName = ctrl.get('sheet_name')?.value ?? '';
      const key = `${this.normalizeFileName(fileName)}__${this.normalizeFileName(sheetName)}`;
      currentValues[key] = {
        question_column: ctrl.get('question_column')?.value,
        answer_column: ctrl.get('answer_column')?.value,
        starting_row: ctrl.get('starting_row')?.value,
        comments_column: ctrl.get('comments_column')?.value,
        attachment_column: ctrl.get('attachment_column')?.value,
      };
    });

    // Clear existing
    while (this.Sheets.length) this.Sheets.removeAt(0);

    // Rebuild, restoring previously filled values
    this.fileSheetMap.forEach((fileEntry) => {
      fileEntry.sheets.forEach((sheet: any) => {
        const key = `${this.normalizeFileName(fileEntry.file_name)}__${this.normalizeFileName(sheet.sheet_name)}`;
        const saved = currentValues[key];

        const group = this.fb.group({
          file_name: [fileEntry.file_name],
          sheet_name: [sheet.sheet_name, Validators.required],
          question_column: [
            saved?.question_column ?? sheet.question_column,
            Validators.required,
          ],
          answer_column: [
            saved?.answer_column ?? sheet.answer_column,
            Validators.required,
          ],
          starting_row: [
            saved?.starting_row ?? sheet.starting_row,
            Validators.required,
          ],
          comments_column: [saved?.comments_column ?? sheet.comments_column],
          attachment_column: [
            saved?.attachment_column ?? sheet.attachment_column,
          ],
        });
        this.Sheets.push(group);
      });
    });
  }

  triggerFileInput(type: 'doc' | 'xls') {
    if (
      this.uploadSelectFile.length > 0 &&
      this.uploadFiletype !== null &&
      this.uploadFiletype !== type
    ) {
      this.notifier.notify(
        'default',
        `Remove existing files before switching to ${type === 'xls' ? 'Excel' : 'PDF/DOC'}`,
      );
      return;
    }
    this._activeInputType = type; // ← track which one was clicked
    if (type === 'xls') {
      this.xlsFileInput.nativeElement.value = '';
      this.xlsFileInput.nativeElement.click();
    } else {
      this.docFileInput.nativeElement.value = '';
      this.docFileInput.nativeElement.click();
    }
  }

  private normalizeFileName(name: string): string {
    return name.trim().toLowerCase().replace(/\s+/g, '_');
  }

  selectParent(items: any) {
    this.selectedParentRfpId = items.id;
    this.selectedParentRfpDetails = items;
    this.selectedRfp = null;
    this.documentListData = [];
    this.pageNo = 1;
    this.parentRfpSelectedList = [
      items.id,
      ...(items.child ?? []).map((item: any) => item.id),
    ];
    if (!items.child || items.child.length === 0) {
      this.selectedRfp = items.id;
    }
    this.getRFPDocuments();
  }

  private getCompanyListAndNavigate(
    targetParentId: any,
    targetCompanyDetails: any,
    targetSubfolderId: any,
  ) {
    this.infosecService.getCompanies().subscribe({
      next: (response: any) => {
        this.companyListData = response['result'];
        this.bodySpinner = false;

        if (!targetParentId || this.companyListData.length === 0) {
          // Fallback to first company
          if (this.companyListData.length > 0) {
            this.selectedCompanyId = this.companyListData[0]['id'];
            this.selectedCompanyDetails = this.companyListData[0];
            this.selectedParentRfpId = this.companyListData[0]['id'];
            this.selectedRfp = null;
            this.selectedRfPDetails = null;
            this.pageNo = 1;
            this.getRFPDocuments();
          }
          return;
        }

        // Find the target parent in the refreshed list
        const parentItem = this.companyListData.find(
          (c: any) => c.id === targetParentId,
        );

        if (!parentItem) {
          // Parent not found, fallback
          this.selectedCompanyId = this.companyListData[0]['id'];
          this.selectedCompanyDetails = this.companyListData[0];
          this.selectedParentRfpId = this.companyListData[0]['id'];
          this.selectedRfp = null;
          this.pageNo = 1;
          this.getRFPDocuments();
          return;
        }

        // Set parent context
        this.selectedParentRfpId = parentItem.id;
        this.selectedCompanyId = parentItem.id;
        this.selectedCompanyDetails = parentItem;

        if (targetSubfolderId) {
          // Find the subfolder in the refreshed list
          const subItem = parentItem.child?.find(
            (sub: any) => sub.id === targetSubfolderId,
          );

          if (subItem) {
            this.selectedRfp = subItem.id;
            this.selectedRfPDetails = subItem;
          } else {
            // Subfolder not found (e.g. was just created, try matching by position — land on parent)
            this.selectedRfp = null;
            this.selectedRfPDetails = null;
          }
        } else {
          // No subfolder target — land on parent company level
          this.selectedRfp = null;
          this.selectedRfPDetails = null;
        }

        this.pageNo = 1;
        this.documentListData = [];
        this.getRFPDocuments();
      },
      error: (errors: HttpErrorResponse) => {
        this.bodySpinner = false;
      },
    });
  }

  onDocFileChange(event: any) {
    if (this._activeInputType !== 'doc') return; // ← ignore if not triggered intentionally
    this._activeInputType = null;
    const input = event.target as HTMLInputElement;
    const files: File[] = Array.from(input.files || []);
    input.value = '';
    if (this.progressLoader) return;
    if (files.length > 0) this.processFiles(files);
  }

  onXlsFileChange(event: any) {
    if (this._activeInputType !== 'xls') return; // ← ignore if not triggered intentionally
    this._activeInputType = null;
    const input = event.target as HTMLInputElement;
    const files: File[] = Array.from(input.files || []);
    input.value = '';
    if (this.progressLoader) return;
    if (files.length > 0) this.processFiles(files);
  }
}
